import { useEffect, useState } from 'react';
// FIXME here is some eslint issue
// eslint-disable-next-line import/no-unresolved
import { loadTranslationsFromSpreadsheet, TranslationsObject } from '@commity-tools/translation-manager';

import translationsJson from '../translations/translations.json';

import translationSettings from './../translation-manager.json';

export function useTranslations(mode: 'json' | 'spreadsheet', locale: string, defaultLocale = 'en-GB') {
  const [translations, setTranslations] = useState<TranslationsObject>(translationsJson);

  useEffect(() => {
    if (mode === 'spreadsheet') {
      console.debug('Loading translations from spreadsheet.');
      loadTranslationsFromSpreadsheet(translationSettings.translationSheet.spreadsheetId)
        .then((translations) => {
          setTranslations(translations);
        })
        .catch((error) => {
          console.error('Error loading translations from spreadsheet:', error);
        });
    }
  }, [mode]);

  return translations[locale] || translations[defaultLocale];
}
